import * as React from "react";
const SvgCircle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 76, height: 76, viewBox: "0 0 76 76", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 38, cy: 38, r: 37.5, stroke: "#D8EDFE" }));
export default SvgCircle;
